import PropTypes from "prop-types";
import { Close as CloseIcon } from "@material-ui/icons";
import {
  Dialog,
  Grid,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  makeStyles,
} from "@material-ui/core";
import Typography from "../Typography";

const useStyles = makeStyles((theme) => ({
  headerDialog: {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    paddingBottom: "0.5rem",
  },
  btnClose: {
    color: "white",
  },
}));

export const SrDialogTitle = ({
  children,
  onClose,
  variant = "h3",
  headerContent,
  coloredHeader,
  ...props
}) => {
  const classes = useStyles();
  return (
    <MuiDialogTitle
      disableTypography
      {...props}
      className={coloredHeader ? classes.headerDialog : undefined}
    >
      <Grid container justifyContent="center" alignItems="flex-start">
        <Grid item xs={10}>
          <Typography variant={variant}>{children}</Typography>
        </Grid>
        <Grid container item xs={2} justifyContent="flex-end">
          {onClose && (
            <IconButton
              size="small"
              aria-label="close"
              color="secondary"
              onClick={onClose}
              className={coloredHeader ? classes.btnClose : undefined}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
      {headerContent}
    </MuiDialogTitle>
  );
};

const SrDialog = ({
  handleClose,
  open,
  children,
  heading,
  headerContent,
  coloredHeader,
  size = "sm",
  actions,
  dialogContentProps,
  ...props
}) => (
  <Dialog
    onClose={handleClose}
    fullWidth
    maxWidth={size}
    open={open}
    scroll="body"
    {...props}
  >
    <SrDialogTitle
      onClose={handleClose}
      headerContent={headerContent}
      coloredHeader={coloredHeader}
    >
      {heading}
    </SrDialogTitle>
    <DialogContent {...dialogContentProps}>{children}</DialogContent>
    {actions && <DialogActions>{actions}</DialogActions>}
  </Dialog>
);

SrDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  heading: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  actions: PropTypes.node,
  headerContent: PropTypes.element,
  coloredHeader: PropTypes.bool,
};

SrDialog.defaultProps = {
  heading: null,
  open: true,
  actions: undefined,
  headerContent: null,
  coloredHeader: false,
};

export default SrDialog;
